export default __webpack_public_path__ + "static/media/aboutImg.e41641c2.jpg";